const getTimeOption = (
  scheduledHours: number[],
  language: string,
  minuteInterval: 15 | 30,
) => {
  const minuteSteps =
    minuteInterval === 15 ? ['00', '15', '30', '45'] : ['00', '30']

  if (language === 'fr') {
    return scheduledHours.reduce((acc, curr) => {
      for (const minute of minuteSteps) {
        if (curr === 24 && minute !== '00') {
          continue
        }
        acc.push(`${curr}:${minute}`)
      }
      return acc
    }, [] as string[])
  } else {
    return scheduledHours.reduce((acc, curr) => {
      const label = get12HoursFormatLabel(curr)
      for (const minute of minuteSteps) {
        if (curr === 24 && minute !== '00') {
          continue
        }
        acc.push(`${label.hour}:${minute} ${label.suffix}`)
      }
      return acc
    }, [] as string[])
  }
}

export const timeOptions = (language: string, minuteInterval: 15 | 30 = 30) =>
  getTimeOption([...Array(24).keys()], language, minuteInterval)

const get12HoursFormatLabel = (hour: number) => {
  const suffix = hour >= 12 ? 'PM' : 'AM'
  let formattedHour = hour % 12 || 12
  //if 00 then it is 12 am

  formattedHour = hour === 0 ? 12 : formattedHour
  return { hour: formattedHour, suffix }
}

export const getDefaultTime = (date = new Date(), language: string) => {
  const hours = date.getHours()
  const minutes = date.getMinutes()
  if (language === 'fr') {
    return `${hours}: ${minutes ? minutes : '00'}`
  } else {
    const suffix = hours >= 12 ? 'PM' : 'AM'
    let formattedHour = hours % 12 || 12
    //if 00 then it is 12 am
    formattedHour = hours === 0 ? 12 : formattedHour
    return `${formattedHour}: ${minutes ? minutes : '00'} ${suffix}`
  }
}

export const generateDate = ({ time, date }: { time: string; date: Date }) => {
  if (time.includes('PM')) {
    const hours = time.split(':')
    if (time.includes('12')) {
      hours[0] = '00'
    }
    date.setHours(parseInt(hours[0]) + 12, parseInt(hours[1]))
  } else if (time.includes('AM')) {
    const hours = time.split(':')
    if (time.includes('12')) {
      hours[0] = '00'
    }
    date.setHours(parseInt(hours[0]), parseInt(hours[1]))
  } else {
    const hours = time.split(':')
    date.setHours(parseInt(hours[0]), parseInt(hours[1]))
  }
  return date
}
